import React from "react";


const reasonsData = [
  {
    id: 1,
    image: "https://img.icons8.com/fluency/96/000000/stopwatch.png",
    title: "Quick Deals",
    description:
      "With all the homes, we ensure the time is always of the essence. Our team works with you to ensure your home is available for you to move into at the earliest possible time.",
  },
  {
    id: 2,
    image: "https://www.svgrepo.com/show/257589/right-chevron-next.svg",
    title: "Experience",
    description:
      "We have years of experience working with people from several cultures and backgrounds. Our agents are highly experienced and excel at what they do.",
  },
  {
    id: 3,
    image: "https://img.icons8.com/fluency/96/000000/sale.png",
    title: "Exclusive Offers",
    description:
      "Our solutions are defined for your custom needs. We give you flexibility and ensure you get the best value for money when you choose AJ Valley Homes.",
  },
  {
    id: 4,
    image: "https://img.icons8.com/fluency/96/000000/happy.png",
    title: "Happy Clients",
    description:
      "Our biggest priority is to make sure our clients are happy with the work we do. Our agents and contractors work to turn your vision into reality.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="chooseus-section">
      <h1 className="chooseus-heading">Why Should You Choose Us?</h1>
      <div className="chooseus-grid">
        {reasonsData.map((item) => (
          <div className="chooseus-card" key={item.id}>
            <img src={item.image} alt={item.title} className="card-image" />
            <h2>{item.title}</h2>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
